import gettext from '@sdk/lang/gettext';
import Switcher from '@sdk/components/forms/Switcher';
import { Feature } from '@sdk/common/features';

import PremiumGuard from '@web/premiumGuard/PremiumGuard';
import usePremiumGuard from '@web/premiumGuard/usePremiumGuard';
import PremiumGuardLabel from '@web/premiumGuard/PremiumGuardLabel';
import getPremiumTooltipId from '@web/premiumGuard/getPremiumTooltipId';
import { PremiumModalNames } from '@web/premiumGuard/constants/modalNames';

import { BadgeWrapper, Control, Description, Title, Wrapper } from './bulkModeSwitch.styles';

type Props = {
  isEnabled: boolean;
  onChange: (value: boolean) => void;
};

export const BulkModeSwitch = ({ isEnabled, onChange }: Props) => {
  const { getPremiumGuardConfig, tooltipRefs } = usePremiumGuard();

  const premiumGuardConfig = getPremiumGuardConfig(Feature.bulkMessages);
  const isFeatureEnabled = premiumGuardConfig.hasAccess;

  return (
    <PremiumGuard
      hasAccess={isFeatureEnabled}
      premiumFeature={Feature.bulkMessages}
      premiumGuardModalName={PremiumModalNames.bulkMessages}
      tooltipRef={tooltipRefs[getPremiumTooltipId(Feature.bulkMessages)]}>
      <Wrapper>
        <Description>
          <Title>
            {gettext('Send a message to each member individually')}
            {!isFeatureEnabled && (
              <BadgeWrapper>
                <PremiumGuardLabel
                  label={premiumGuardConfig.requiredPlan}
                  tooltipId={premiumGuardConfig.tooltipId}
                  tooltipText={premiumGuardConfig.tooltipContent}
                />
              </BadgeWrapper>
            )}
          </Title>

          {gettext(
            'The message you type below will be shared through private conversations, so only you can get the response.'
          )}
        </Description>
        <Control>
          <Switcher disabled={!isFeatureEnabled} small onChange={onChange} value={isEnabled} />
        </Control>
      </Wrapper>
    </PremiumGuard>
  );
};
